import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import Pagination from 'react-js-pagination';
import moment from 'moment';

import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Table,
  Container,
  Row,
} from 'reactstrap';

import Header from 'components/Headers/Header.js';
import GeneralQuestionService from './GeneralQuestionService';

export default class ListGeneralQuestions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questions: [],
      activePage: 1,
      itemsCountPerPage: 20,
      totalItemsCount: 0,
      pageRangeDisplayed: 5,
      loading: false,
    };
  }

  componentDidMount() {
    this.fetchQuestions(1);
  }

  fetchQuestions(page) {
    const { itemsCountPerPage } = this.state;
    this.setState({ loading: true });

    GeneralQuestionService.listQuestions(page, itemsCountPerPage)
      .then((res) => {
        this.setState({
          questions: res.data.data,
          itemsCountPerPage: res.data.perPage,
          totalItemsCount: res.data.totalData,
          activePage: res.data.currentPage,
          loading: false,
        });
      })
      .catch(() => this.setState({ loading: false }));
  }

  handlePageChange = (pageNumber) => {
    this.setState({ activePage: pageNumber }, () => this.fetchQuestions(pageNumber));
  };

  deleteQuestion = (id) => {
    if (!window.confirm('Are you sure you want to delete this question?')) return;
    GeneralQuestionService.deleteQuestion(id)
      .then(() => {
        NotificationManager.success('Question deleted successfully!', 'Success!', 2000);
        this.fetchQuestions(this.state.activePage);
      })
      .catch(() => NotificationManager.error('Failed to delete question.', 'Error', 2000));
  };

  render() {
    const { questions, loading } = this.state;

    return (
      <>
        <Header />
        <Container className="mt--7" fluid>
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Link to="/admin/general-questions/create" className="btn btn-info">
                    Add New Question +
                  </Link>
                </CardHeader>
                <CardHeader className="border-0">
                  <h3 className="mb-0">General Questions</h3>
                </CardHeader>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">Order</th>
                      <th scope="col">Question</th>
                      <th scope="col">Type</th>
                      <th scope="col">For Agent</th>
                      <th scope="col">Options</th>
                      <th scope="col">Status</th>
                      <th scope="col">Created At</th>
                      <th scope="col" />
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="8" className="text-center">Loading...</td>
                      </tr>
                    ) : questions.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="text-center">No questions found.</td>
                      </tr>
                    ) : (
                      questions.map((q) => (
                        <tr key={q._id}>
                          <td>{q.order ?? 0}</td>
                          <td style={{ maxWidth: 220 }}>
                            {q.text && q.text.length > 60 ? `${q.text.substring(0, 60)}...` : q.text}
                          </td>
                          <td>
                            <Badge color="info">{q.type}</Badge>
                          </td>
                          <td>
                            <Badge color={q.for_agent ? 'primary' : 'secondary'}>
                              {q.for_agent ? 'Yes' : 'No'}
                            </Badge>
                          </td>
                          <td style={{ maxWidth: 180 }}>
                            {q.options && q.options.length > 0
                              ? q.options.slice(0, 3).join(', ') + (q.options.length > 3 ? ` +${q.options.length - 3} more` : '')
                              : '-'}
                          </td>
                          <td>
                            <Badge color={q.status ? 'success' : 'danger'}>
                              {q.status ? 'Active' : 'Inactive'}
                            </Badge>
                          </td>
                          <td>{moment(q.createdAt).format('MMM DD, YYYY')}</td>
                          <td className="text-right">
                            <UncontrolledDropdown>
                              <DropdownToggle
                                className="btn-icon-only text-light"
                                href="#pablo"
                                role="button"
                                size="sm"
                                color=""
                                onClick={(e) => e.preventDefault()}
                              >
                                <i className="fas fa-ellipsis-v" />
                              </DropdownToggle>
                              <DropdownMenu className="dropdown-menu-arrow" right>
                                <Link to={`/admin/general-questions/edit/${q._id}`}>
                                  <DropdownItem>Edit</DropdownItem>
                                </Link>
                                <DropdownItem onClick={() => this.deleteQuestion(q._id)}>
                                  Delete
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
                <CardFooter className="py-4">
                  <nav aria-label="...">
                    <Pagination
                      activePage={this.state.activePage}
                      itemsCountPerPage={this.state.itemsCountPerPage}
                      totalItemsCount={this.state.totalItemsCount}
                      pageRangeDisplayed={this.state.pageRangeDisplayed}
                      onChange={this.handlePageChange}
                      itemClass="page-item"
                      linkClass="page-link"
                    />
                  </nav>
                </CardFooter>
              </Card>
            </div>
          </Row>
        </Container>
      </>
    );
  }
}
